/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */

import type { DataMessageResponse_Lifestyle_ } from "../models/DataMessageResponse_Lifestyle_";
import type { DataMessageResponse_LifestylePreferencesOptions_ } from "../models/DataMessageResponse_LifestylePreferencesOptions_";
import type { DataResponse_Lifestyle_ } from "../models/DataResponse_Lifestyle_";
import type { Lifestyle } from "../models/Lifestyle";
import type { MealTime } from "../models/MealTime";
import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";
export class LifestyleService {
  /**
   * Update Lifestyle
   * Updates the lifestyle options for a user.
   * @param xUserId
   * @param requestBody
   * @returns DataMessageResponse_Lifestyle_ Successful Response
   * @throws ApiError
   */
  public static updateLifestyleApiV1LifestylePut(
    xUserId: string,
    requestBody: Lifestyle,
  ): CancelablePromise<DataMessageResponse_Lifestyle_> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v1/lifestyle",
      headers: {
        "x-user-id": xUserId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Lifestyle
   * Returns the lifestyle options for a user.
   * @param xUserId
   * @returns DataResponse_Lifestyle_ Successful Response
   * @throws ApiError
   */
  public static getLifestyleApiV1LifestyleGet(
    xUserId: string,
  ): CancelablePromise<DataResponse_Lifestyle_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/lifestyle",
      headers: {
        "x-user-id": xUserId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Lifestyle Preference Options
   * Get available lifestyle preference options for a given meal time.
   * @param mealTime
   * @returns DataMessageResponse_LifestylePreferencesOptions_ Successful Response
   * @throws ApiError
   */
  public static getLifestylePreferenceOptionsApiV1LifestyleMealTimeOptionsGet(
    mealTime: MealTime,
  ): CancelablePromise<DataMessageResponse_LifestylePreferencesOptions_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/lifestyle/{meal_time}/options",
      path: {
        meal_time: mealTime,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Lifestyle By Admin
   * Used by an admin to get information about a user's lifestyle options.
   * @param userId
   * @returns DataResponse_Lifestyle_ Successful Response
   * @throws ApiError
   */
  public static getLifestyleByAdminApiV1LifestyleUserIdGet(
    userId: string,
  ): CancelablePromise<DataResponse_Lifestyle_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/lifestyle/{user_id}",
      path: {
        user_id: userId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
